import React from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function MicrosoftCallback() {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const [error, setError] = React.useState(null);
  const processed = React.useRef(false);

  React.useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    const err = params.get("error_description") || params.get("error");
    if (err) {
      setError(err);
      return;
    }
    if (!code || !state) {
      setError("Missing code or state");
      return;
    }
    (async () => {
      try {
        const r = await api.post("/auth/microsoft/callback", { code, state });
        await checkAuth();
        // If the caller stashed a post-login destination (used by the wall
        // display's "Sign in to view" flow) honour it instead of the default.
        let target = r.data.redirect_to || "/app/dashboard";
        try {
          const stashed = sessionStorage.getItem("post_login_redirect");
          if (stashed) {
            sessionStorage.removeItem("post_login_redirect");
            target = stashed;
          }
        } catch { /* sessionStorage unavailable — fall through */ }
        window.history.replaceState({}, "", target);
        navigate(target, { replace: true });
      } catch (e) {
        setError(e?.response?.data?.detail || "Microsoft sign-in failed");
      }
    })();
  }, [navigate, checkAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="max-w-sm text-center space-y-3 p-8">
        {error ? (
          <>
            <div className="font-heading text-lg text-red-700">Sign-in failed</div>
            <div className="text-sm text-slate-600">{error}</div>
            <a href="/" className="inline-block mt-4 text-sm text-blue-600 hover:underline">← Back to sign-in</a>
          </>
        ) : (
          <div className="flex items-center justify-center gap-3 text-slate-500">
            <div className="h-2 w-2 rounded-full bg-blue-600 pulse-dot" />
            <span className="font-mono text-sm">Completing Microsoft sign-in…</span>
          </div>
        )}
      </div>
    </div>
  );
}
